export const API_AUTH_HEADER = 'Authorization';

export const ROLE_PREFIXES = {
  'owner': 'provider-owner',
  'manager': 'location-manager',
};
